import {Injectable} from '@angular/core';
import {DialogsService, LangService, LoaderService, NavigateService} from 'ngx-satoris';
import {Person} from '../models/person';
import {ApiService} from './api.service';
import {DocumentType, Document} from '../models/user';
import {VISA_FORM_CONFIG} from '../models/local-form';
import {Direction, VisaFN, VisaFormConfig} from '../models/forms';
import {CartSyncRow, Request, consumeDataCall, RequestWithDuplicata} from '../models/request';
import {BehaviorSubject} from 'rxjs';
import {VISA_ARRIVAL_FORM_CONFIG} from '../models/arrival-form';
import {DialogParticipantsComponent} from '../../components/dialogs/dialog-participants/dialog-participants.component';
import * as uuid from 'uuid';
import {EXTEND_VISA_FORM_CONFIG} from '../models/VISA-ZIM/extend-form';
import {convertUpperCase} from '../utils/string';

export type CartScenario = 'document' | 'person' | 'visa' | 'tracking-control';
export type CartState = 'meansPayment' | 'onlinePayment' | 'processPayment' | 'selfie';

declare const window: any;

export interface FormApplication {
  travelName: string,
  plannedEntry: string,
  currentPerson?: Person,
  submitted?: boolean,
  requests?: Request[],
  visaFeesAndTerms: boolean,
  payOnline?: 'true' | 'false',
  isRevision?: boolean,
  skipValidRevision?: boolean,
  isExtend?: boolean,
  revisionFields?: VisaFN[],
  requestId?: string,
}
export interface CartStoreRow {
  id?: number;
  currentApplication?: FormApplication;
}

export interface CartStoreRowOLD {
  id?: number;
  user_id?: number;
  person_id?: number;
  state?: CartState;
  fromRoute?: CartScenario;
  document_type?: DocumentType;
  form_config?: VisaFormConfig;
  revisionPayment?: RequestWithDuplicata;
}

@Injectable({
  providedIn: 'root'
})
export class CartService {
  idbstorage: IDBDatabase;
  originalVisaFormConfig: VisaFormConfig = {...VISA_FORM_CONFIG};
  originalVisaArrivalFormConfig: VisaFormConfig = {...VISA_ARRIVAL_FORM_CONFIG};
  originalExtendVisaFormConfig: VisaFormConfig = {...EXTEND_VISA_FORM_CONFIG};
  CART_STORE = 'cart';
  SYNC_STORE = 'sync';
  REVISION_STORE = 'revision';
  EXTEND_STORE = 'extend';
  syncQueue: consumeDataCall[] = [];
  currentApplication: FormApplication = {travelName: '', plannedEntry: null, currentPerson: null, requests: [], visaFeesAndTerms: false};
  currentApplication$: BehaviorSubject<FormApplication> = new BehaviorSubject(undefined);
  syncQueue$: BehaviorSubject<consumeDataCall> = new BehaviorSubject(undefined);

  //OLD
  cartDatas: CartStoreRowOLD;
  cartDatas$: BehaviorSubject<CartStoreRowOLD> = new BehaviorSubject(undefined);
  actualDocument: Document;
  selfiePerson: string;
  actualPerson: Person;
  actualPerson$: BehaviorSubject<Person> = new BehaviorSubject(undefined);
  scenario: CartScenario;
  state: CartState;
  isShopping = false;
  revisionPayment: RequestWithDuplicata;

  constructor(private nav: NavigateService,
    private api: ApiService,
    private dialog: DialogsService,
    private loader: LoaderService,
    private lang: LangService) {
    const dbreq = window.indexedDB.open('lu.satoris.paycode', 1);
    dbreq.onsuccess = (e: any) => {
      this.idbstorage = e.target.result;
      this.getStorageOLD();
    };
    dbreq.onupgradeneeded = (e: any) => {
      const db = e.target.result;
      if(!db.objectStoreNames.contains(this.CART_STORE)) {
        db.createObjectStore(this.CART_STORE, {keyPath: 'id'});
      }
    };
  }


  updateParticipants(participants: Person[]) {
    participants.forEach(p => {
      if(!this.currentApplication.requests) this.currentApplication.requests = [];
      if(!this.currentApplication.requests.some(r => r.person.id === p.id)) {
        this.currentApplication.requests.push({person: p});
      }
    });
    this.currentApplication.requests = this.currentApplication.requests?.filter(r => participants.find(p => p.id === r.person.id));
    this.currentRequest = this.currentApplication.requests.find(r => r.person.id === this.currentApplication.currentPerson.id);
  }

  get currentRequest(): Request {
    return this.currentApplication?.requests.find(r => r.person.id === this.currentApplication.currentPerson.id);
  }

  set currentRequest(request: Request) {
    const index = this.currentApplication?.requests.findIndex(r => r.person.id === this.currentRequest.person.id);
    if(index > -1) {
      this.currentApplication.requests[index] = request;
    }
  }

  personRequestIsValid(person: Person) {
    const request: Request = this.currentApplication.requests.find(r => r.person.id === person.id);
    if((!request.nationality && !this.currentApplication.isExtend) || (!request.passportType && !this.currentApplication.isExtend) || !request.visaType || !request.formConfig) {
      return false;
    }
    for(const configKey in request.formConfig) {
      if(!request.formConfig[configKey].submitted) {
        return false;
      }
      if(!request.formConfig[configKey].visited) {
        return false;
      } else if(request.formConfig[configKey].visited && request.formConfig[configKey].errors?.length) {
        return false;
      }
    }
    return true;
  }

  allPersonRequestsAreValid() {
    return this.currentApplication.requests.every(r => this.personRequestIsValid(r.person));
  }

  openParticipants() {
    this.dialog.openDialog(DialogParticipantsComponent, 'sm');
  }

  saveCurrentApplication(next = true, fromPrevious = false, id = this.CART_STORE): Promise<void> {
    return new Promise((resolve) => {
      this.setStorage({currentApplication: this.currentApplication}, fromPrevious, this.currentApplication?.isRevision ? this.REVISION_STORE : this.currentApplication?.isExtend ? this.EXTEND_STORE : id ).then(() => {
        localStorage.setItem('lastApplicationType_'+this.api.userInfo.id, this.currentApplication?.isRevision ? this.REVISION_STORE : this.currentApplication?.isExtend ? this.EXTEND_STORE : this.CART_STORE);
        if(next) {
          this.currentApplication$.next(this.currentApplication);
          resolve();
        } else resolve();
      });
    });
  }

  editSyncQueue(data: consumeDataCall, remove = false) {
    if(remove) {
      this.syncQueue = this.syncQueue.filter(d => d.paymentId !== data.paymentId);
    } else {
      if(!this.syncQueue.some(d => d.paymentId === data.paymentId)) {
        this.syncQueue.push(data);
      }
    }
    return new Promise((resolve, reject) => {
      const trans = this.idbstorage.transaction(this.SYNC_STORE, 'readwrite');
      const objStore = trans?.objectStore?.(this.SYNC_STORE);
      const request = objStore.put({id: this.api.userInfo.id, data: this.syncQueue});
      request.onsuccess = resolve;
      request.onerror = reject;
    });
  }

  deleteSavedApplication(next = true, id = this.CART_STORE) {
    const waitPromise = this.removeStorage(id);
    if(next) this.currentApplication$.next(this.currentApplication);
    return waitPromise;
  }

  startApplication(kiosk = false, application?: FormApplication, visaFormConfig?: VisaFormConfig, person?: Person) {
    sessionStorage.removeItem('paymentReason');
    this.currentApplication = {travelName: '', plannedEntry: null, currentPerson: null, requests: [], visaFeesAndTerms: false};
    if(application) {
      if(application.isRevision) {
        this.deleteSavedApplication(true, this.REVISION_STORE);
        this.currentApplication = application;
        this.currentApplication.currentPerson = this.currentApplication.requests[0].person;
        this.updateParticipants([this.currentApplication.requests[0].person]);
        this.currentApplication.requests[0].formConfig = visaFormConfig;
        this.saveCurrentApplication(true, false, this.REVISION_STORE);
        setTimeout(() => {
          this.loader.loading(true, {type: 'info', message: 'request.revision', btnLabel: 'yes', custom: {closeBtnLabel: 'no', icon: 'rocket'}}).then((done: boolean) => {
            this.changeSkip(done);
            application.isExtend ? this.nav.to('visa-extend', undefined, {queryParams: {direction: Direction.NEXT}}) : this.nav.to('passport-type', undefined, {queryParams: {direction: Direction.NEXT}});
          });
        });
        this.currentApplication.skipValidRevision = true;
      } else if(application.isExtend) {
        this.deleteSavedApplication(true, this.EXTEND_STORE);
        this.currentApplication = application;
        this.currentApplication.currentPerson = this.currentApplication.requests[0].person;
        this.updateParticipants([this.currentApplication.requests[0].person]);
        this.currentApplication.requests[0].formConfig = visaFormConfig;
        this.saveCurrentApplication(true, false, this.EXTEND_STORE);
        this.nav.to('visa-extend');
      }
    } else if(kiosk) {
      this.currentApplication.skipValidRevision = false;
      this.deleteSavedApplication(true, this.CART_STORE);
      this.currentApplication.travelName = this.getUniqueReference([], 0);
      this.currentApplication.plannedEntry = null;
      const req: Request = {
        person: {
          firstName: '',
          lastName: '',
          nationalNumber: '',
          batchIds: [],
          passportNumber: '',
          id: undefined,
          linkType: null,
          otherLinkType: ''
        }};
      this.currentApplication.currentPerson = req.person;
      this.updateParticipants([req.person]);
      this.saveCurrentApplication(true, false, this.CART_STORE);
      this.nav.to('passport-type');
    } else {
      this.currentApplication.skipValidRevision = false;
      this.readStorage(this.CART_STORE).then(row => {
        if(row) {
          this.loader.loading(true, {type: 'question', message: 'request.existSaved', btnLabel: 'yes', custom: {closeBtnLabel: 'no'}}).then((done  ) => {
            if(done) {
              this.loadCurrentApplication(this.CART_STORE).then(() => {
                if(this.currentRequest?.latestRouteVisited) {
                  this.nav.to(this.currentRequest.latestRouteVisited);
                } else {
                  this.nav.to('travel-name');
                }
              });
            } else {
              this.deleteSavedApplication(true, this.CART_STORE);
              this.nav.to('travel-name');
              if(person) {
                this.updateParticipants([person]);
              }
            }
          });
        } else {
          this.nav.to('travel-name');
        }
      });
    }
  }

  checkMissingParticipants() {
    if(!this.api.userRole.isKiosk && this.currentApplication && !this.api.userRole.isWorker && !this.currentApplication?.isRevision && !this.currentApplication?.isExtend) {
      this.currentApplication.requests = this.currentApplication?.requests.filter(r => this.api.listPersons?.find(p => p.id === r.person.id));
      if(!this.api.listPersons?.some(p => p.id === this.currentApplication?.currentPerson?.id)) {
        this.currentApplication.currentPerson = this.currentApplication.requests[0]?.person || null;
      }
    }
  }

  setStorage(data: CartStoreRow, fromPrevious = true, id = this.CART_STORE): Promise<unknown> {
    data.id = this.api.userInfo.id;
    return (fromPrevious ? this.readStorage() : Promise.resolve({})).then(row => new Promise((resolve, reject) => {
      const trans = this.idbstorage.transaction(id, 'readwrite');
      const objStore = trans?.objectStore?.(id);
      const request = objStore.put({...row, ...data});
      request.onsuccess = resolve;
      request.onerror = reject;
    }).then(() => this.loadCurrentApplication()));
  }

  private readStorage(id = this.CART_STORE): Promise<CartStoreRow | consumeDataCall[]> {
    return new Promise((resolve, reject) => {
      const objStore = this.idbstorage?.transaction(id, 'readonly').objectStore(id);
      const query = objStore?.openCursor();
      let resolved = false;
      let defaultRow: CartStoreRow;
      query.onsuccess = (e: any) => {
        const cursor = e.target.result;
        if(cursor) {
          if(!resolved && cursor.value.id === this.api.userInfo?.id) {
            resolve(cursor.value);
            resolved = true;
          } else if(!cursor.value.person_id) {
            defaultRow = cursor.value;
          }
          cursor.continue();
        } else if(!resolved) {
          resolve(defaultRow);
        }
      };
      query.onerror = reject;
    });
  }

  loadCurrentApplication(id = this.CART_STORE) {
    return new Promise((resolve) => {
      this.readStorage(this.currentApplication?.isRevision ? this.REVISION_STORE : this.currentApplication?.isExtend ? this.EXTEND_STORE : id).then(row => {
        if(!row) {
          this.removeStorage().then(() => resolve(undefined));
        } else {
          this.currentApplication = (row as CartStoreRow).currentApplication;
          this.checkMissingParticipants();
          this.currentRequest = this.currentApplication?.requests.find(r => r.person.id === this.currentApplication.currentPerson.id);
          resolve(this.currentRequest);
        }
      });
    });
  }

  removeStorage(id = this.CART_STORE) {
    return new Promise((resolve, reject) => {
      this.currentApplication = {travelName: '', plannedEntry: null, currentPerson: null, requests: [], submitted: false, visaFeesAndTerms: false};
      this.currentRequest = undefined;
      const trans = this.idbstorage?.transaction?.(id, 'readwrite');
      const objStore = trans?.objectStore?.(id);
      const request = objStore?.clear();
      if(request) {
        request.onsuccess = resolve;
        request.onerror = reject;
      } else {
        resolve(undefined);
      }
    });
  }

  getOriginalForm(docType?: DocumentType): VisaFormConfig {
    switch(docType || this.currentRequest?.visaType?.id) {
    case DocumentType.ZWEVISA:
    case DocumentType.ZWEVISA_DOUBLE:
    case DocumentType.ZWEVISA_KAZA:
    case DocumentType.ZWEVISA_MULTIPLE:
      return this.originalVisaFormConfig;
    case DocumentType.ZWEVISAARR:
    case DocumentType.ZWEVISAARR_DOUBLE:
    case DocumentType.ZWEVISAARR_KAZA:
    case DocumentType.ZWEVISAARR_MULTIPLE:
    case DocumentType.ZWEENTRY:
      return this.originalVisaArrivalFormConfig;
    case DocumentType.ZWEVISAEXTC:
    case DocumentType.ZWEVISAEXTAB:
      return this.originalExtendVisaFormConfig;
    }
  }

  areConfigEqual(config1: VisaFormConfig, config2: VisaFormConfig) {
    const keys1 = Object.keys(config1);
    const keys2 = Object.keys(config2);
    if(keys1.length !== keys2.length) {
      return false;
    }
    return true;
  }

  getUniqueReference(notInArray: string[], limit = 6): string {
    let ref = uuid.v4().toUpperCase();
    if(limit > 0) {
      ref = ref.slice(0, limit);
    }
    if(notInArray.includes(ref)) {
      return this.getUniqueReference(notInArray, limit);
    } else {
      return ref;
    }
  }

  resetKioskRequest() {
    this.loader.loading(true, {
      type: 'warn',
      message: 'onArrival.reset.ask',
      btnLabel: 'yes',
      custom: {closeBtnLabel: 'no'}
    }).then((done: boolean) => {
      if(done) {
        this.startApplication(true);
      }
    });
  }

  callSyncQueue(recall = false) {
    if(this.api.queueIsSyncing && !recall) {
      return;
    } else {
      this.api.queueIsSyncing = true;
      return this.loadSyncQueue().then(data => {
        if(!this.syncQueue.length || !this.api?.userInfo || !data) {
          this.api.queueIsSyncing = false;
          this.syncQueue = [];
          return;
        }
        const retryDelay = 1000;
        return this.api.consumePayment(this.syncQueue[0].paymentId, this.syncQueue[0].consumedPlaceId, this.syncQueue[0].createdPlaceId, this.syncQueue[0].createdAt, this.syncQueue[0].consumeMessage, this.syncQueue[0].consumeData, this.syncQueue[0].localUsageUntil).then(() => {
          let data = this.syncQueue[0];
          return this.editSyncQueue(this.syncQueue[0], true).then(() => {
            this.syncQueue$.next(data);
            data = null;
            if(this.syncQueue.length) {
              this.callSyncQueue(true);
            } else {
              this.api.queueIsSyncing = false;
              return;
            }
          });
        }).catch((err: any) => {
          const failedData = this.syncQueue[0];
          if(err.includes('client.extended.uuidUsed') || err.includes('client.extended.maxUsageCountReached')) {
            window.sendTicket('[ERROR Log]: Consume error', `Agent ID : ${this.api.userInfo.id}`, `${this.api.userInfo.name}`, `${this.api.userInfo.accountName}`, this.lang.transform('error.consumeError', {error: err, applicationReference: failedData.paymentId}));
            return this.editSyncQueue(failedData, true).then(() => new Promise<void>((resolve) => {
              setTimeout(() => {
                resolve(this.callSyncQueue(true));
              }, retryDelay);
            }));
          } else {
            return this.editSyncQueue(failedData, true).then(() => {
              if(failedData?.agentId === this.api.userInfo.id) {
                return this.editSyncQueue(failedData).then(() => new Promise<void>((resolve) => {
                  setTimeout(() => {
                    resolve(this.callSyncQueue(true));
                  }, retryDelay);
                }));
              } else {
                return new Promise<void>((resolve) => {
                  setTimeout(() => {
                    resolve(this.callSyncQueue(true));
                  }, retryDelay);
                });
              }
            });
          }
        });
      }).catch(() => {
        this.api.queueIsSyncing = false;
        this.syncQueue = [];
      });
    }
  }

  loadSyncQueue() {
    return new Promise((resolve) => {
      this.readStorage(this.SYNC_STORE).then(row => {
        const dataFromRow = row as CartSyncRow;
        if(dataFromRow.id !== this.api.userInfo.id) {
          this.syncQueue = [];
          resolve(false);
        }
        this.syncQueue = dataFromRow?.data as consumeDataCall[] || [];
        resolve(true);
      }).catch(() => {
        this.syncQueue = [];
        resolve(false);
      });
    });
  }

  isFnInRevision(fn: VisaFN, notInRevision = false) {
    if(notInRevision) {
      return this.currentApplication?.isRevision && !this.currentApplication?.revisionFields?.some(f => f === fn);
    } else {
      return this.currentApplication?.isRevision && this.currentApplication?.revisionFields?.some(f => f === fn);
    }
  }

  changeSkip(event: any) {
    this.currentApplication.skipValidRevision = event;
  }

  //OLD

  setStorageOLD(data: CartStoreRowOLD, fromPrevious = true) {
    data.id = 0;
    return (fromPrevious ? this.readStorageOLD(0) : Promise.resolve({})).then(row => new Promise((resolve, reject) => {
      const trans = this.idbstorage.transaction(this.CART_STORE, 'readwrite');
      const objStore = trans?.objectStore?.(this.CART_STORE);
      const request = objStore.put({...row, ...data});
      request.onsuccess = resolve;
      request.onerror = reject;
    }).then(() => this.getStorageOLD(data.id)));
  }

  private readStorageOLD(id: number): Promise<CartStoreRowOLD> {
    return new Promise((resolve, reject) => {
      const objStore = this.idbstorage.transaction(this.CART_STORE, 'readonly').objectStore(this.CART_STORE);
      const query = objStore.openCursor();
      let resolved = false;
      let defaultRow: CartStoreRowOLD;
      query.onsuccess = (e: any) => {
        const cursor = e.target.result;
        if(cursor) {
          if(!resolved && cursor.value.id === id) {
            resolve(cursor.value);
            resolved = true;
          } else if(!cursor.value.person_id) {
            defaultRow = cursor.value;
          }
          cursor.continue();
        } else if(!resolved) {
          resolve(defaultRow);
        }
      };
      query.onerror = reject;
    });
  }

  getStorageOLD(id = 0) {
    return this.readStorageOLD(id).then(row => {
      if(!row) {
        this.nav.to('dashboard');
        this.removeStorageOLD();
      } else {
        this.cartDatas = row;
        this.cartDatas$.next(this.cartDatas);
        this.scenario = row.fromRoute;
        this.state = row.state;
        this.isShopping = !!this.state;
        this.revisionPayment = row.revisionPayment;
        if(!this.actualDocument && this.cartDatas.document_type) {
          this.actualDocument = this.api.userInfo?.server?.paymentRequests?.find((doc: Document) => convertUpperCase(doc.id) === convertUpperCase(row.document_type));
        }
        if(!this.actualPerson && this.cartDatas?.person_id) {
          this.actualPerson = this.api.listPersons?.find((person: Person) => +person.id === +this.cartDatas.person_id);
          this.actualPerson$.next(this.actualPerson);
        }
      }
    });
  }

  removeOneElementOLD(remove: 'fromRoute' | 'document_type' | 'person_id' | 'state') {
    const dataTemp = this.cartDatas;
    if(!dataTemp) return;
    delete dataTemp[remove];
    if(remove === 'person_id') {
      this.actualPerson = undefined;
      this.actualPerson$.next(this.actualPerson);
    } else if(remove === 'document_type') {
      this.actualPerson = null;
    }
    this.cartDatas = dataTemp;
    this.cartDatas$.next(this.cartDatas);
    return this.setStorage(this.cartDatas, false);
  }

  removeStorageOLD(preserveDatas = false) {
    if(preserveDatas && this.cartDatas){
      delete this.cartDatas.form_config;
      this.setStorageOLD(this.cartDatas, true);
    } else {
      this.revisionPayment = undefined;
      this.cartDatas = undefined;
      this.cartDatas$.next(this.cartDatas);
      this.actualPerson = undefined;
      this.actualDocument = undefined;
      this.scenario = undefined;
      this.state = undefined;
      this.isShopping = undefined;
      const trans = this.idbstorage?.transaction?.(this.CART_STORE, 'readwrite');
      const objStore = trans?.objectStore?.(this.CART_STORE);
      const request = objStore?.clear();
      if(request){
        request.onsuccess = () => undefined;
        request.onerror = () => undefined;
      }
    }
  }

  getOriginalFormOLD(docType?: DocumentType): VisaFormConfig {
    switch(docType || this.cartDatas?.document_type) {
    case DocumentType.ZWEVISA:
    case DocumentType.ZWEVISA_DOUBLE:
    case DocumentType.ZWEVISA_KAZA:
    case DocumentType.ZWEVISA_MULTIPLE:
      return this.originalVisaFormConfig;
    case DocumentType.ZWEVISAARR:
    case DocumentType.ZWEVISAARR_DOUBLE:
    case DocumentType.ZWEVISAARR_KAZA:
    case DocumentType.ZWEVISAARR_MULTIPLE:
    case DocumentType.ZWEENTRY:
      return this.originalVisaArrivalFormConfig;
    }
  }
}
